import Axios from 'axios';
import React from 'react';
import { PdfDataTable } from './table';
import { Spin } from '../loading';

interface PdfDownloadProps {
  title: string;
  path: string;
  downloadPath: string;
}

interface State {
  data: any[];
  loading: boolean;

  paginate: {
    currentPage: number;
    total: number;
    take: number;
  };
}

const take = 10;

const initialState: State = {
  data: [] as any[],
  loading: false,
  paginate: {
    currentPage: 1,
    take,
    total: Infinity,
  },
};

export const PdfDownloadPage: React.FC<PdfDownloadProps> = (props: any) => {
  const { title, path, downloadPath } = props;

  const [state, setState] = React.useState<State>(initialState);

  React.useEffect(() => {
    const isLoading = state.loading;
    const { paginate } = state;

    if (!isLoading) {
      setState((prev: any) => ({ ...prev, loading: true }));
      Axios.get(`/${path.toLowerCase()}`, {
        params: {
          skip: (paginate.currentPage - 1) * paginate.take,
          take: paginate.take,
        },
      })
        .then((res: any) => {
          const [total] = res.data;
          const data = convert(res.data);
          const { paginate } = state;
          setState((prev: any) => ({
            ...prev,
            data,
            paginate: {
              ...paginate,
              total,
              take,
            },
          }));
        })
        .finally(() => {
          setState((prev: any) => ({ ...prev, loading: false }));
        });
    }
    // eslint-disable-next-line
  }, [state.paginate, path]);

  const columnTitle = [
    {
      title: 'File name',
      dataIndex: 'fileName',
    },
    // {
    //   title: "File Upload Date",
    //   dataIndex: "fileUploadDate"
    // },
  ];
  function convert(dataArray: Array<any>) {
    const response = [];
    for (const data of dataArray) {
      const returnObject = {
        fileName: data.name,
        // fileUploadDate: data.stat.mtime,
        downloadable: data.downloadable,
      };
      response.push(returnObject);
    }
    return response;
  }

  return (
    <div className="date-datatable">
      <div className="wrapper">
        <span className="title">{title}</span>
      </div>
      <div className="bottom">
        <Spin spin={state.loading}>
          {state.data.length > 0 && (
            <PdfDataTable
              columns={columnTitle}
              data={state.data}
              downloadPath={downloadPath}
            />
          )}
        </Spin>
      </div>
    </div>
  );
};
